import styled from 'styled-components'

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    flex: 1;
`

export default FlexRow